<template>
  <div class="m-2 mt-4">
    <div class="d-flex flex-row justify-content-start bg-white rounded-top border-bottom">
      <i class="material-icons mr-1">shopping_cart</i>
      <p class="m-0">CART</p>
    </div>
    <b-list-group style=" " class="pt-2">
      <b-list-group-item v-if="Object.keys(items).length === 0">Enter part details to get started..</b-list-group-item>
      <b-list-group-item v-for="(id) in sortedOrderItems" :key="id" class="bg-white">
        <order-item :partNumber="items[id].part_number"></order-item>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OrderItem from "@/components/OrderItem";
export default {
  name: "order-items-container",
  components: {
    OrderItem
  },
  computed: {
    sortedOrderItems() {
      return Object.keys(this.items).reverse();
    },
    ...mapGetters("order", ["items"])
  }
};
</script>

<style lang="scss" scoped>
</style>
